<template>
  <div class="reviews-head" :class="{ _slim: slim }">
    <div class="reviews-head__container">
      <button-icon tag="span" :size="slim ? 'md' : 'lg'">
        <template #icon>
          <icon icon="star" />
        </template>
        <span
          class="reviews-head__rating"
          itemprop="aggregateRating"
          itemscope=""
          itemtype="https://schema.org/AggregateRating"
        >
          <meta itemprop="ratingValue" :content="rating" />
          <meta itemprop="reviewCount" :content="count" />
          <meta itemprop="bestRating" :content="bestRating" />
          {{ $t("reviews.rating") }} {{ rating }}
        </span>
      </button-icon>
      <divider-dot class="reviews-head__dot u-text-secondary" />
      <div class="reviews-head__count">{{ $tc("reviews.reviews", count) }}</div>
    </div>

    <VideoReviews v-if="!slim" :tourId="tourId" />
  </div>
</template>

<script>
import ButtonIcon from "@/components/ui-kit/button-icon/index.vue";
import Icon from "@/components/icons/index.vue";
import DividerDot from "@/components/ui-kit/divider-dot/index.vue";
import VideoReviews from "./video-reviews.vue";

export default {
  components: {
    ButtonIcon,
    Icon,
    DividerDot,
    VideoReviews,
  },
  props: {
    rating: {
      type: [Number, String],
      required: true,
    },
    bestRating: {
      type: [Number, String],
      default: 5,
    },
    count: {
      type: Number,
      required: true,
    },
    slim: {
      type: Boolean,
      default: false,
    },
    tourId: {
      type: [Number, String],
    },
  },
};
</script>

<style lang="scss" scoped>
$b: ".reviews-head";

#{$b} {
  margin-bottom: 25px;

  &__container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;    
  }

  &__rating,
  &__dot,
  &__count {
    font-weight: bold;
    font-size: 24px;
    line-height: 115%;

    #{$b}._slim & {
      font-weight: 600;
      font-size: 18px;
    }
  }
}
</style>
